import { render, staticRenderFns } from "./downloadProgress.vue?vue&type=template&id=64ad56c8&"
import script from "./downloadProgress.vue?vue&type=script&lang=js&"
export * from "./downloadProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports